import * as types from './action-types';
import marcaBlancaServices from '../../api/services/marcaBlancaServices';

export function setLandingData(data) {
  return { type: types.SET_LANDING_DATA, payload: data };
}

export function getLandingData(id) {
  return async function thunk(dispatch, getState) {
    try {
      const store = getState();
      const appId = store.applicationState.applicationId;
      const payload = await marcaBlancaServices.getSeccionLanding(id, appId, store);
      const data = payload?.object ?? payload ?? null;

      dispatch(setLandingData(data));
      return data;
    } catch (err) {
      dispatch(setLandingData(null));
      return null;
    }
  };
}
